import { render, staticRenderFns } from "./SkillBadge.vue?vue&type=template&id=44ec42e8&"
import script from "./SkillBadge.vue?vue&type=script&lang=js&"
export * from "./SkillBadge.vue?vue&type=script&lang=js&"
import style0 from "./SkillBadge.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports